import React, { useState } from "react";
import "./CalorieFAQ.css"; // Make sure to import the CSS for styling

const CalorieFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const calorieFaqData = [
    {
      question: "How do I calculate my daily calorie needs?",
      answer:
        "Your daily calorie needs depend on factors such as age, weight, height, activity level, and fitness goals. Use a calorie calculator that incorporates these variables to estimate your required intake.",
    },
    {
      question: "What is a calorie deficit, and how does it work?",
      answer:
        "A calorie deficit occurs when you consume fewer calories than your body burns, leading to weight loss. To achieve a safe calorie deficit, aim to reduce your intake by 500-750 calories per day.",
    },
    {
      question: "How many calories do I need to lose weight?",
      answer:
        "To lose weight, calculate your Total Daily Energy Expenditure (TDEE) and reduce it by 500-750 calories. For example, if your TDEE is 2,500 calories, aim for 1,750-2,000 calories per day.",
    },
    {
      question: "How many calories should I eat to build muscle?",
      answer:
        "To build muscle, consume calories in a slight surplus, typically 250-500 calories above your TDEE. Pair this with a high-protein diet and strength training for optimal results.",
    },
    {
      question: "Can I lose fat and gain muscle at the same time?",
      answer:
        "Yes, this is called body recomposition. Focus on consuming sufficient protein, maintaining a slight calorie deficit, and performing strength training to lose fat while gaining muscle.",
    },
    {
      question: "What is TDEE, and why is it important?",
      answer:
        "TDEE (Total Daily Energy Expenditure) is the total number of calories your body burns in a day, including basic metabolic functions, activity, and exercise. Knowing your TDEE helps you plan calorie intake for weight loss, maintenance, or muscle gain.",
    },
    {
      question: "How many calories do I need to maintain my weight?",
      answer:
        "To maintain your weight, consume calories equal to your TDEE. This varies by age, activity level, and other factors, but a calorie calculator can provide a personalized estimate.",
    },
    {
      question: "Can I use a calorie intake calculator for weight loss?",
      answer:
        "Yes, calorie intake calculators help you estimate the number of calories you need to consume daily to create a calorie deficit for weight loss. Simply input your details and set your goal.",
    },
    {
      question: "What are empty calories, and should I avoid them?",
      answer:
        "Empty calories come from foods and drinks with little to no nutritional value, like sugary drinks, candy, and processed snacks. Limiting these helps you focus on nutrient-dense foods that support your goals.",
    },
    {
      question: "How does my activity level affect calorie needs?",
      answer:
        "Your activity level significantly impacts your TDEE. Sedentary individuals require fewer calories, while active people need more to fuel their energy expenditure and recovery.",
    },
    {
      question: "How do I calculate my calorie intake for a calorie surplus?",
      answer:
        "To calculate a calorie surplus, add 250-500 calories to your TDEE. This is ideal for muscle gain, provided you're also following a strength training program.",
    },
    {
      question: "What happens if I eat too few calories?",
      answer:
        "Consuming too few calories can lead to fatigue, nutrient deficiencies, and a slowed metabolism. Ensure you maintain a minimum calorie intake to support basic body functions.",
    },
    {
      question: "What’s the difference between BMR and TDEE?",
      answer:
        "BMR (Basal Metabolic Rate) is the number of calories your body burns at rest, while TDEE includes all activities, such as exercise and daily movement. TDEE is used to determine your total calorie needs.",
    },
    {
      question: "Should I track calories every day?",
      answer:
        "Tracking calories daily can be helpful for achieving specific goals, but it's not mandatory. Focus on portion sizes, nutrient-dense foods, and mindful eating if you prefer a less rigid approach.",
    },
    {
      question: "How do I adjust my calorie intake if I hit a plateau?",
      answer:
        "If you hit a plateau, reassess your TDEE, activity levels, and calorie intake. You may need to reduce calories further for weight loss or increase them slightly for muscle gain.",
    },
    {
      question: "What are macronutrients, and how do they affect calorie intake?",
      answer:
        "Macronutrients—protein, carbohydrates, and fats—provide calories and fuel your body. Balancing your macronutrient intake ensures you meet your energy and nutrient needs for your fitness goals.",
    },
    {
      question: "How does age affect calorie requirements?",
      answer:
        "As you age, your calorie needs typically decrease due to a slower metabolism and reduced activity levels. Adjust your calorie intake accordingly to maintain a healthy weight.",
    },
    {
      question: "What’s the best time to eat calories for weight loss or muscle gain?",
      answer:
        "Timing matters less than total calorie intake, but distributing your calories evenly throughout the day can help with energy levels, performance, and appetite control.",
    },
    {
      question: "Can calorie calculators help with intermittent fasting?",
      answer:
        "Yes, calorie calculators can help you determine your daily calorie needs, which you can then fit into your fasting and eating windows for intermittent fasting plans.",
    },
    {
      question: "Do calorie calculators work for everyone?",
      answer:
        "Calorie calculators provide estimates based on averages. While they work for most people, individual factors like metabolism, health conditions, and genetics may require adjustments.",
    },
  ];
  

  return (
    <section className="protein-faq-section">
      <h2>FAQs</h2>
      <div className="faq-container" id="faq">
        {calorieFaqData.map((faq, index) => (
          <div key={index} className="faq-item">
            <div className="faq-question" onClick={() => handleToggle(index)}>
              {faq.question}
              <span
                className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`}
              ></span>
            </div>
            {activeIndex === index && (
              <div className="faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default CalorieFAQ;
